
/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllUserGroups = (state: { userGroups: any; }) => state.userGroups.userGroups;
export const selectUserGroupsPagination = (state: { userGroups: any; }) => state.userGroups.pagination;
export const selectUserGroupsSearchValue = (state: { userGroups: any; }) => state.userGroups.searchValue;
export const selectSearchValue = (state: { userGroups: any; }) => state.userGroups.searchValue;
export const selectUsersByGroup = (state: { userGroups: any }) => state.userGroups.usersByGroup;
export const selectUsersByGroupLoading = (state: { userGroups: any }) => state.userGroups.loading;
export const selectPaginationDetails = (state: { userGroups: any }) => state.userGroups.page;
export const selectUsersByGroupError = (state: { userGroups: any }) => state.userGroups.error;